<!-- page starts-->
<section class="page-wrapper">
	<div class="sessionticket-top-section cf">
		<div class="container">
			<div class="sessionticket-top-detail">
				<div class="sessionticket-top-logo">
					<img src="assets/images/season-ic.png">
				</div>
				<h2>Purchase your season ticket now and receive the benefits next season</h2>
			</div>
		</div>
		<div class="sessionticket-top-overlay"></div>
	</div>
	<div class="sessionticket-center-section cf">
		<div class="container">
			<div class="sessionticket-center-detail cf">
				<div class="sessionticket-center-box">
					<div class="sessionticket-center-box-text">
						<p>An Ashton United Season ticket card</p>
					</div>
					<div class="sessionticket-center-box-logo">
						<img src="assets/images/Bitmap.png">
					</div>
				</div>
				<div class="sessionticket-center-box">
					<div class="sessionticket-center-box-text">
						<p>An Ashton United Season ticket card</p>
					</div>
					<div class="sessionticket-center-box-logo">
						<img src="assets/images/Bitmap.png">
					</div>
				</div>
				<div class="sessionticket-center-box">
					<div class="sessionticket-center-box-text">
						<p>An Ashton United Season ticket card</p>
					</div>
					<div class="sessionticket-center-box-logo">
						<img src="assets/images/Bitmap.png">
					</div>
				</div>
				<div class="sessionticket-center-box">
					<div class="sessionticket-center-box-text">
						<p>An Ashton United Season ticket card</p>
					</div>
					<div class="sessionticket-center-box-logo">
						<img src="assets/images/Bitmap.png">
					</div>
				</div>
			</div>
			<div class="sessionticket-center-season-section cf">
				<div class="sessionticket-center-season-section-inner cf">
					<div class="sessionticket-center-season-text">
						<p>Rockin Robin price is available for any Season Tickets purchased before 1st September 2020
						</p>
					</div>
					<div class="sessionticket-center-season-logo">
						<a href="javascript:void(0);"><img src="assets/images/season-ic.png"></a>
					</div>
				</div>
				<div class="sessionticket-center-season-section-overlay"></div>
			</div>
			<div class="sessionticket-center-season-holders cf">
				<div class="sessionticket-center-season-holders-top">
					<h2>{{seasonList?.title}}</h2>
					<p>{{seasonList?.subtitle}}</p>
				</div>
				<div class="sessionticket-center-season-holders-bottom">
					<div class="checkout-center-detail cf">
						<div class="checkout-center-detail-left">
							<div class="away-fans">
								<table border="0" cellspacing="0" cellpadding="0">
									<tr *ngFor="let season of seasonList?.seasonticket_detail">
										<td>
											<p><span class="images"><img src="assets/images/adult-ic.svg"></span><span
													class="name">{{season?.title}}</span></p>
										</td>
										<td>£{{season?.amount}}.00</td>
										<td>
											<div class="select-box">
												<div class="product-quantity">
													<div class="product-quantity-box">
														<input data-min="0"
															id="quantity{{season?.seasonticket_detail_id}}"
															name="quantity" readonly="true" type="text" value="0">
														<input data-min="0" hidden
															id="price{{season?.seasonticket_detail_id}}" name="price"
															readonly="true" type="text" value="{{season?.amount}}">
														<div class="quantity-selectors-container">
															<div class="quantity-selectors"><button
																	id="{{season?.seasonticket_detail_id}}"
																	class="increment-quantity"
																	type="button"><span>+</span></button><button
																	data-id="{{season?.seasonticket_detail_id}}"
																	id="{{season?.seasonticket_detail_id}}"
																	class="decrement-quantity"
																	type="button"><span>−</span></button>
															</div>
														</div>
													</div>
												</div>
											</div>
										</td>
									</tr>
								</table>
							</div>
							<div class="sessionticket-center-season-holders-tc">
								<h3>T&Cs*</h3>
								<p>Concessions (Over 65) available to pensioners with a valid bus pass or other ID, or
									college/university students (16-18s & 18-21+) with a valid student ID from the
									college/university (proof will be needed on the turnstile, this will be in the form
									of a card that has a photo of the individual and a valid date. NUS cards are
									accepted too; same rules apply).</p>
								<p>Child season ticket holders must be accompanied by an adult.</p>
								<p>Anyone seeking entry without a valid ID when asked will be required to pay the full
									£10 adult price.</p>
								<p>Please note there will be a small admin charge for any Replacement Season Ticket of
									£10.00 per card.</p>
							</div>
						</div>
						<div class="checkout-center-detail-right">
							<h2>Bookings Summary</h2>
							<div class="checkout-center-detail-right-general-admission">

								<div class="checkout-center-detail-right-general-admission-detail cf">
									<div class="checkout-center-detail-right-general-admission-name">
										<p *ngFor="let season of seasonList?.seasonticket_detail">{{season?.title}}</p>

									</div>
									<div class="checkout-center-detail-right-general-admission-number">
										<p *ngFor="let season of seasonList?.seasonticket_detail"
											id="pNos{{season?.seasonticket_detail_id}}">0 Nos.</p>

									</div>
									<div class="checkout-center-detail-right-general-admission-price">
										<p *ngFor="let season of seasonList?.seasonticket_detail"
											id="pPrice{{season?.seasonticket_detail_id}}">£00.00</p>

									</div>
								</div>
								<div class="checkout-center-detail-payment">
									<div class="checkout-payment-payable-btn">
										<a (click)="add_to_cart()" id="addtocart" class="show">Add To Cart</a>
										<a routerLink="/sessioncheckout" id="gototcart" class="hidden">Go To Cart</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section><!-- page ends-->